import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { resolveContentHtml } from "@/lib/url";

const DEFAULT_TITLE = "Polityka prywatności";
const DEFAULT_SUBTITLE = "Wspólnota Mieszkaniowa Dąbrówka Wiślana – Aluzyjna 25 C/D/E/F";

export default function PrivacyPage() {
    const [title, setTitle] = useState(DEFAULT_TITLE);
    const [subtitle, setSubtitle] = useState(DEFAULT_SUBTITLE);
    const [html, setHtml] = useState("");

    useEffect(() => {
        document.title = `${DEFAULT_TITLE} – Dąbrówka Wiślana`;
        api.get("/settings").then((r) => {
            const d = r.data || {};
            if (d.privacy_policy_title) setTitle(d.privacy_policy_title);
            if (d.privacy_policy_subtitle) setSubtitle(d.privacy_policy_subtitle);
            if (d.privacy_policy_html) setHtml(d.privacy_policy_html);
        }).catch(() => {});
    }, []);

    return (
        <div data-testid="privacy-page" className="min-h-screen bg-white">
            <div className="bg-[#092E22] text-white py-12">
                <div className="max-w-4xl mx-auto px-6 lg:px-10">
                    <Link to="/" className="text-[#D4A537] text-sm hover:underline" data-testid="privacy-back-link">← Powrót</Link>
                    <h1 className="font-serif text-4xl md:text-5xl mt-4" data-testid="privacy-title">{title}</h1>
                    <p className="text-white/70 mt-2" data-testid="privacy-subtitle">{subtitle}</p>
                </div>
            </div>
            <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
                <div
                    className="rich-content text-gray-700 leading-relaxed text-base md:text-lg"
                    data-testid="privacy-content"
                    dangerouslySetInnerHTML={{ __html: resolveContentHtml(html) }}
                />
            </div>
        </div>
    );
}
